import { ChangeDetectorRef, Component, Inject } from '@angular/core';
import { LabelUpdateFunctionParams } from 'src/app/components/label-marker/label-maker.dialog.component';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { LabelObject, JoiEvent, Ranking } from 'globals/store/events.data';
import { ManageWrapperComponent, TabGroup } from './manage-wrapper.component';
import { PublicEditProfileInfo, publicEditProfileStatusTypes, getPublicEditProfileInfo } from 'src/app/store/performers.era';
import { SocialLink } from 'globals/store/performers.data';
import { imageUploaderDisplayTypes } from 'globals/store/files.model';
import { SponsorsTableData } from 'src/app/helpers/table-column-types';
import { NestedProgramInfo, SponsorSessionInfo } from 'src/app/store/reselectors/performerSponsors.reselector';
import { SessionSelectorData, SessionSelectorDialogComponent } from 'src/app/components/performers/session-selector.dialog.component';
import { getXYFromEventAndWidth } from '../../helpers/helpers';
import { ManageSessionData, ManageSessionComponent } from './manage-session.component';
import { openDialogGetResult } from 'src/app/helpers/angular-helpers';
import { JoiComment } from 'globals/store/tasks.data';
import { ConfirmDeleteData, openConfirmDeleteGetResult } from 'src/app/components/dialog.confirmDelete.component';
import { sponsorTabs, Sponsor, sponsorStatus } from 'globals/store/sponsors.data';
import { sponsorDisplayTypes } from 'src/app/store/sponsors.era';
import { sponsorsTableReselector, sessionSponsorReselector } from 'src/app/store/reselectors/sponsors.reselector';
import { RankingDialogData, RankSelectDialogComponent } from '../sponsors/rank-select.dialog.component';
import { Wrapper } from 'src/app/components/wrapper.component';
import { clipboardEditingPrivilegesReselector } from '../../store/reselectors/accounts.reselector';
import { ClipLabel } from 'globals/store/entity.data';
import { associatedAssetsReselector } from '../../store/reselectors/entity.reselector';
import { UpdateQuestionOutput } from '../../components/entities/custom-questions.component';
import { MenuHoverButtonComponent } from 'src/app/components/buttons/menu-hover-button.component';
import { ToggleTabComponent } from 'src/app/components/buttons/toggle-tab.component';
import { TipTextComponent } from 'src/app/components/misc/tip-text.component';
import { BinaryShareToggle } from '../share/binary-share-toggle.component';
import { ImageUploaderComponent } from 'src/app/components/wrappers/image-uploader.component';
import { InputEditorComponent } from 'src/app/components/joi-input/input-editor';
import { ManageSocialLinksComponent } from './manage-social.component';
import { AssetsComponent } from '../assets/assets.component';
import { StatusWrapperComponent } from 'src/app/components/wrappers/status-wrapper.component';
import { BigAndGreyComponent } from 'src/app/components/cards/big-and-grey.component';
import { TrafficLightComponent } from 'src/app/components/misc/traffic-light.component';
import { AddManageWrapperComponent } from 'src/app/components/wrappers/add-manage-wrapper.component';
import { ManageCallToActionComponent } from './manage-call-to-action.component';
import { ManageContactDetailsComponent } from './manage-contact-details.component';
import { CustomQuestionsAppComponent } from 'src/app/components/entities/custom-questions-app.component';
import { EditAssociatedAssetsManager } from '../assets/edit-associated-assets-manager.component';
import { ManageContactComponent } from './manage-contact.component';
import { CommonModule } from '@angular/common';
import { ChatBoxComponent } from './chat-box.component';
import { EntityTasksComponent } from './entity-tasks.component';

@Component({
    selector: 'manage-sponsor',
    templateUrl: './manage-sponsor.html',
    styleUrls: ['./manage-dialogs.scss'],
    standalone: true,
    imports: [ManageWrapperComponent, EntityTasksComponent, ChatBoxComponent, CommonModule, ManageContactComponent, EditAssociatedAssetsManager, CustomQuestionsAppComponent, ManageContactDetailsComponent, MenuHoverButtonComponent, ToggleTabComponent, TipTextComponent, BinaryShareToggle, ImageUploaderComponent, InputEditorComponent, ManageCallToActionComponent, AddManageWrapperComponent, TrafficLightComponent, BigAndGreyComponent, ManageSocialLinksComponent, AssetsComponent, StatusWrapperComponent ],
})
export class ManageSponsorComponent extends Wrapper<ManageSponsorComponent> {

  _file = 'manage-sponsor'
  labels;
  sponsor: Sponsor
  tabs = sponsorTabs
  event: JoiEvent
  labelMap: LabelObject
  tabGroups: TabGroup[] = [{ tabs: [
    { id: sponsorTabs.details, name: 'Sponsor profile' },
    { id: sponsorTabs.sessions, name: 'Sessions' },
    { id: sponsorTabs.assets, name: 'Associated Assets' },
    { id: sponsorTabs.quickNotes, name: 'Quick Notes', icon: 'sticky18' },
    { id: sponsorTabs.contact, name: 'Workforce contact' },
    { id: sponsorTabs.tasks, name: 'Tasks' },
  ]}]
  selectedTab

  sponsorDisplayTypes = sponsorDisplayTypes
  imageUploaderDisplayTypes = imageUploaderDisplayTypes
  sponsorShareable: PublicEditProfileInfo
  generatingEditCode = false
  sponsorTableData: SponsorsTableData
  sessionProgramList: NestedProgramInfo[] = []
  sessionList: SponsorSessionInfo[] = []
  statusOptions = Object.values(sponsorStatus)
  sponsorTypes: { [id:string]: Ranking } = {}
  threeDotSessionOptions = [{ name: 'Remove sponsor from session', id: 'delete' }]
  clipLabel: ClipLabel

  associatedAssetIds: string[] = []

  constructor(public changeDetectorRef: ChangeDetectorRef, public dialogRef: MatDialogRef<ManageSponsorComponent>, @Inject(MAT_DIALOG_DATA) public data: ManageSponsorData) {
    super()
    this.selectProp(associatedAssetsReselector, data.sponsorId, 'associatedAssetIds')

    this.sponsorShareable = getPublicEditProfileInfo('profile', this.data.sponsorId, null) // set the default shareable
    this.selectCallback(clipboardEditingPrivilegesReselector, null, canClip => {
      if (canClip && !this.data.readOnly && !this.clipLabel) this.clipLabel = '+ ADD TO CLIPBOARD'
    })

    this.subProp(this.store.select('sponsors', 'sponsorTypes'), 'sponsorTypes')
    this.subCallback(this.store.select(sponsorsTableReselector), ({ sponsorTableRowsById }) => {
      this.sponsorTableData = sponsorTableRowsById[data.sponsorId]
    })
    this.subCallback(this.store.select(sessionSponsorReselector, this.data.sponsorId), ({ sessionList, sessionProgramList }) => {
      this.sessionList = sessionList
      this.sessionProgramList = sessionProgramList
    })
    this.subCallback(this.store.select('events', 'labelMaps', 'sponsor_labels'), labelMap => {
      this.labels = Object.values(labelMap)
      this.labelMap = labelMap
    })
    this.subCallback(this.store.select('shareables', 'sponsor', this.data.sponsorId), sponsorShareable => {
      if(sponsorShareable) this.sponsorShareable = sponsorShareable
    })
    this.subProp(this.store.select('events', 'event'), 'event')
    this.subPropMutable(this.store.select('sponsors', 'entities', this.data.sponsorId), 'sponsor')
  }

  public labelUpdateFunction({ labelTemplate, labelsChanged, labelsToggled, labels }: LabelUpdateFunctionParams) {
    // Updates to labels on an event don't go through the label dialog template but rather the entire event changes dialog (and are only saved on "save changes" or what have you)  The label template can still change, though
    if (labelsToggled) {
      this.sponsor.labels = labels
      this.saveSponsor()
    }
    if (labelsChanged) {
      this.eventService.updateEvent(this.eventService.eventId, { sponsor_labels: labelTemplate })
    }
  }

  saveStars(ev){
    this.sponsor = {...this.sponsor, stars: ev}
    this.saveSponsor()
  }

  async manageSession(session: SponsorSessionInfo) {
    const data: ManageSessionData = { sessionId: session.id }
    this.changeDetectorRef.detach()
    await openDialogGetResult(this.dialog, ManageSessionComponent, { autoFocus: false, disableClose: true, data, panelClass: 'full-screen-modal' })
    this.changeDetectorRef.reattach()
  }

  sessionDotMenuSelection({ event, option }, session: SponsorSessionInfo) {
    switch (option) {
      case 'delete':
        this.deleteFromSession(session, event)        
        break;
      default:
        console.log(`Missing selection [${option}] from three dot menu`)
        break;
    }
  }

  changeHideInPublish(){
    this.sponsor.hideInPublish = !this.sponsor.hideInPublish;
    this.saveSponsor();
  }

  updateTitle(newTitle: string) {
    this.sponsor.name = newTitle
    this.saveSponsor()
  }


  changeTab(tab) {
    this.selectedTab = tab
  }

  
  changeImage(result) {
    this.sponsor.logoUrl = result ? result.thumbUrl : null
    this.sponsor.fullLogoUrl = result ? result.photoUrl : null
    this.saveSponsor()
  }

  saveSocialLinks(links: SocialLink[]) {
    this.sponsor.social = links
    this.saveSponsor()
  }

  async changeWorkforceContact(personEmail: string) {
    const WFContact = personEmail === this.sponsor.WFContact ? null : personEmail
    this.sponsor = { ...this.sponsor, WFContact }
    this.saveSponsor()
  }


  exit() {
    this.dialogRef.close()
  }

  async clip() {
    switch(this.clipLabel) {
      case '+ ADD TO CLIPBOARD':
        this.clipLabel = 'SAVING...'
        await this.sponsorService.templateSponsors([this.sponsor])
        this.clipLabel = 'ADDED'
        break
      default:
        break // nothing to do
    }
  }
  

  toggleConfirmed() {
    this.sponsor.confirmed = !this.sponsor.confirmed
    this.saveSponsor()
  }

  updateCustomQuestion(data: UpdateQuestionOutput) {
    const { id, answer } = data
    this.sponsor.customQuestions[id] = answer
    this.saveSponsor()
  }

  saveSponsor() {
    this.sponsorService.updateSponsor(this.sponsor)
  }

  async delete() {
    this.sponsorService.deleteSponsor(this.sponsor)
    this.dialogRef.close()
  }

  toggleSponsorProfile(){
    if (!this.sponsorShareable || !this.sponsorShareable.code) {
      this.createSponsorEditProfileCode()
    } else if(this.sponsorShareable && this.sponsorShareable.status !== publicEditProfileStatusTypes.Off){
      this.changeSponsorProfileStatus(publicEditProfileStatusTypes.Off)
    }else if(this.sponsorShareable.code){
      this.changeSponsorProfileStatus(publicEditProfileStatusTypes.Active)
    }
  }

  changeSponsorProfileStatus(status){
    this.shareService.updateProfileInfo({ code:this.sponsorShareable.code, status, sponsorId:this.sponsor.id })
  }

  async createSponsorEditProfileCode() {
    this.generatingEditCode = true;
    await this.shareService.createEditProfileCode(this.sponsor.id, this.event.eventId, 'sponsor')
    this.generatingEditCode = false
  }

  saveQuickNotes(quickNotes: JoiComment[]) {
    // console.log({ quickNotes })
    this.sponsor.quickNotes = quickNotes
    this.saveSponsor()
  }
  
  changeStatus(session: SponsorSessionInfo, status: string) {
    this.sponsorService.changeSponsorStatus(session.id, session.programId, status, this.data.sponsorId)
  }

  addToASession(event) {
    const data: SessionSelectorData = { nestedProgramList: this.sessionProgramList, ...getXYFromEventAndWidth(event, 300), sponsorId: this.sponsor.id }
    this.dialog.open(SessionSelectorDialogComponent, { width: '300px', data, backdropClass: 'clear', disableClose: true })
  }

  async deleteFromSession(session, event: Event) {
    // Confirmation is nested in the status-wrapper component
    const rect = (<HTMLElement>event.target).getBoundingClientRect();
    const data: ConfirmDeleteData = {
      title: 'Remove ' + this.sponsor.name + ' from this session',
      deleteButtonText: 'REMOVE',
      rect,
      bottomOffset: -45,
      dialog: this.dialog
    }
    const del = await openConfirmDeleteGetResult(data)
    if (!del) return
    this.sponsorService.deleteSponsorFromSession(session, this.data.sponsorId)
  }

  async manageSponsorType() {
    const rect = (<HTMLElement>document.getElementById('sponsor-type')).getBoundingClientRect()
    const position =  { top: rect.bottom - 2, left: rect.left }
    const data: RankingDialogData = {
      position,
      ranks: this.event.sponsorTypes,
      selectedRankId: this.sponsor.sponsorTypeId || null,
      type: 'Sponsor type'
    }
    const oldId = data.selectedRankId
    const oldLevelsSerialized = JSON.stringify(data.ranks)
    const { selectedRankId, ranks: sponsorLevels  } = await openDialogGetResult<{ selectedRankId: string, ranks: Ranking[] }>(this.dialog, RankSelectDialogComponent, { width: '300px', disableClose: false, data, backdropClass: 'clear' }) // mutates data in place
    if (JSON.stringify(sponsorLevels) !== oldLevelsSerialized) {
      this.sponsorService.updateSponsorTypes(sponsorLevels)
    }
    if (oldId !== selectedRankId) {
      this.sponsor.sponsorTypeId = selectedRankId
      this.sponsorService.updateSponsor(this.sponsor)
    }
  }


}

export interface ManageSponsorData {
  sponsorId: string
  readOnly: boolean
}
